import { useQuery } from "@tanstack/react-query"

import {
  getUsinage,
  listUsinages,
  suggestNextLotNumber,
  type UsinageListFilter,
} from "@/features/milling/api/milling.api"

export const millingKeys = {
  all: ["milling"] as const,
  list: (status: UsinageListFilter) => ["milling", "list", status] as const,
  detail: (id: string | number) => ["milling", "detail", String(id)] as const,
  nextLotNumber: ["milling", "next-lot-number"] as const,
}

export function useUsinages(status: UsinageListFilter = "all") {
  return useQuery({
    queryKey: millingKeys.list(status),
    queryFn: () => listUsinages(status),
  })
}

export function useUsinage(usinageId: string | number | undefined) {
  return useQuery({
    queryKey: millingKeys.detail(usinageId ?? ""),
    queryFn: () => getUsinage(usinageId as string | number),
    enabled: !!usinageId,
  })
}

// Fetches the next canonical `LOT-YYYY-####` for this exporter so the
// fabrication dialog can pre-fill it. Operator can override before
// submitting, so we keep the query stale-aggressive: a fresh value is
// only meaningful at dialog-open time.
export function useNextLotNumber(enabled = true) {
  return useQuery({
    queryKey: millingKeys.nextLotNumber,
    queryFn: () => suggestNextLotNumber(),
    enabled,
    staleTime: 0,
    gcTime: 0,
  })
}
